



























































































import { uploadImage } from '@/api/common'
import { showError } from '@/utils/common'
import { imageTypes, uploadHandle } from '@/utils/upload'
import { computed, defineComponent, inject, reactive, Ref, ref, set, nextTick } from '@vue/composition-api'
import { Upload } from 'element-ui'
import SettingBox from '@/components/SettingBox.vue'

export default defineComponent({
    components: {
        [Upload.name]: Upload,
        SettingBox
    },
    props: {
        isShowRight: {
            type: Boolean,
            default: true
        },
        option:{
            type: Boolean,
            default: true
        },
        upLoadNumber:{
            type: Number,
            default: 50
        },
        useFileName:{
            type: Boolean,
            default: false
        }
    },
    setup(props, { root, refs }) {
        const isCollapse = ref(true)
        const setIsCollapse = ref(false)
        const itemObj: any = inject('itemObj')

        const optionObj = reactive({
            imgs: computed(() => itemObj?.message_entity.options.filter((v: any) => !v.is_system)),
            systemOptions: computed(() => itemObj?.message_entity.options.filter((v: any) => v.is_system))
        })

        const previewList = computed(() => itemObj.message_entity.options.map((v: any) => v.link))

        const imageUploadInfo = reactive({
            loading: false,
            index: null as null | number,
            before: (file: File) => {
                return uploadHandle(file, 1)
            },
            request: async (value: any) => {
                imageUploadInfo.loading = true
                try {
                    const { url } = await uploadImage({
                        file: value.file
                    })
                    let location = 0
                    if (value.data.type == 'edit') {
                        itemObj.message_entity.options[value.data.index].link = url
                        location = value.data.index
                    } else {
                        const index = itemObj.message_entity.options.filter((v: any) => !v.is_system).length
                        const data = {
                            link: url,
                            text:props.useFileName?value.file.name.substring(0, value.file.name.lastIndexOf('.')): `${root.$i18n.t('project.image')}${index + 1}`
                        }
                        if (value.data.index >= 0) {
                            location = value.data.index + 1
                            itemObj.message_entity.options.insert(location, data)
                        } else {

                            const options = itemObj.message_entity.options.filter((item: any) => !item.is_system)
                            location = options.length
                            itemObj.message_entity.options.insert(location, data)
                        }
                    }
                    nextTick(() => {
                        const input = document.getElementById(`optionInputRef${url}`)
                        input?.focus()
                    })
                } catch (error) {
                    showError(error)
                }
                imageUploadInfo.loading = false
            }
        })

        const onDeleteOption = async (item: any, index: number) => {
            itemObj.message_entity.options.splice(index, 1)
        }

        return {
            itemObj,
            previewList,
            imageTypes,
            imageUploadInfo,
            isCollapse,
            setIsCollapse,
            onDeleteOption,
            optionObj
        }
    }
})
